export default __webpack_public_path__ + "static/media/osl-logo.3c94d357.svg";